import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { useEffect } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { LogTipoTabela } from "../../../../../../common/utils/log_tabela_tipo";
import { FormSwitchInput } from "../../../../../../common/components/masked_inputs/react_forms/form_switch_input";
import { defaultTermoCadastroForm, TermoCadastroForm, TermoCadastroSchema } from "../../../schemas/termo_lista/termoListaCadastro";
import { Termo } from "../../../../domain/models/termo";

type props = {
    open: boolean,
    saving: boolean,
    loading: boolean,
    selectedTermo?: Termo
    handleOpenChangeHistory: (idTabela: number | null, tipoTabela: LogTipoTabela | null) => void
    onClose: () => void,
    onSubmit: (form: TermoCadastroForm) => void,
}

export const CadastroTermoModal = ({
    open,
    saving,
    loading,
    selectedTermo,
    handleOpenChangeHistory,
    onClose,
    onSubmit,
}: props) => {

    const hookFormCadastro = useForm<TermoCadastroForm>({
        mode: "onSubmit",
        reValidateMode: "onSubmit",
        defaultValues: defaultTermoCadastroForm,
        resolver: zodResolver(TermoCadastroSchema),
    });

    useEffect(() => {
        if (selectedTermo) {
            hookFormCadastro.setValue('idTermo', selectedTermo.idTermo);
            hookFormCadastro.setValue('codigo', selectedTermo.codigo ?? '');
            hookFormCadastro.setValue('nome', selectedTermo.nome ?? '');
            hookFormCadastro.setValue('descricao', selectedTermo.descricao ?? '');
            hookFormCadastro.setValue('ativo', selectedTermo.ativo ?? true);

        } else {
            hookFormCadastro.reset(defaultTermoCadastroForm);
        }
    }, [selectedTermo, hookFormCadastro]);


    return (
        <BaseFormControlledModal
            open={open}
            saving={saving}
            loading={loading}
            width={"70rem"}
            title="Cadastro Termo"
            onClose={onClose}
            leftButtonSlot={
                selectedTermo &&
                <PrimaryButton
                    buttonColor="yellow"
                    onClick={() => handleOpenChangeHistory(selectedTermo?.idTermo ?? null, LogTipoTabela.TERMO)}>
                    <span className="text-xs">
                        Historico de alterações
                    </span>
                </PrimaryButton>}
            onSubmit={hookFormCadastro.handleSubmit(onSubmit)}>

            <FormContainer title={"Informações"} arrangement="fullRow">
                <>

                    <div className=" w-[40%] flex items-start justify-between">
                        <label className="font-medium text-gray-700">Ativo:</label>
                        <FormSwitchInput
                            activeLabel="Sim"
                            inactiveLabel="Não"
                            name="ativo"
                            readOnly={saving}
                            reactHookForm={hookFormCadastro}
                        />
                    </div>

                    <DefaultFormInput
                        name='codigo'
                        label="Código do Termo"
                        readOnly={false}
                        required={true}
                        reactHookForm={hookFormCadastro}
                    />

                    <DefaultFormInput
                        name='nome'
                        label="Nome do Termo"
                        readOnly={false}
                        required={true}
                        reactHookForm={hookFormCadastro}
                    />

                    <DefaultFormInput
                        name={'descricao'}
                        label="Descrição do Termo"
                        readOnly={saving}
                        required={false}
                        multiline={true}
                        rows={12}
                        minRows={5}
                        maxRows={14}
                        reactHookForm={hookFormCadastro}
                    />

                </>
            </FormContainer>

        </BaseFormControlledModal>
    );
}